import { render } from "./ProvinceFilter.vue?vue&type=template&id=122428ea&scoped=true&ts=true"
import script from "./ProvinceFilter.ts?vue&type=script&lang=ts"
export * from "./ProvinceFilter.ts?vue&type=script&lang=ts"

import "./ProvinceFilter.scss?vue&type=style&index=0&id=122428ea&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-122428ea"]])

export default __exports__